import React from "react";
import {
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuGroup,
  MenuDivider,
  Tooltip,
  Spinner,
} from "@chakra-ui/react";
import {
  ChevronDownIcon,
  ViewIcon,
  ExternalLinkIcon,
  RepeatIcon,
  CheckCircleIcon,
  CloseIcon,
  InfoOutlineIcon,
  EditIcon,
} from "@chakra-ui/icons";

const HOVER_SCALE = { transform: "scale(1)" };

const InvoiceActionsMenu = ({
  invoice,
  sendingReminderFor,
  updatingInvoice,
  onViewPdf,
  onSendReminder,
  onOpenViewModal,
  onMarkPaid,
  onMarkUnpaid,
  onEdit, // 👈 NEW
}) => {
  const hasPdf = Boolean(invoice?.pdfUrl);
  const isSending = sendingReminderFor === invoice?.invoiceId;
  const isUpdating = updatingInvoice === invoice?.invoiceId;

  return (
    <Menu isLazy placement="bottom-end">
      <Tooltip label="Open invoice actions" hasArrow>
        <MenuButton
          as={Button}
          size="sm"
          rightIcon={<ChevronDownIcon />}
          colorScheme="blue"
          _hover={HOVER_SCALE}
        >
          Actions
        </MenuButton>
      </Tooltip>

            <MenuList minW="240px">
              <MenuGroup title="Invoice">
                <MenuItem
                  onClick={() => onOpenViewModal?.(invoice)}
                  icon={<InfoOutlineIcon />}
                >
                  View Details
                </MenuItem>

                <MenuItem
                  onClick={() => onViewPdf?.(invoice)}
                  icon={<ExternalLinkIcon />}
                >
                  View PDF
                </MenuItem>

                {/* 🔁 Force regeneration using backend flag */}
                <MenuItem
                  onClick={() => onViewPdf?.(invoice, { regenerate: true })}
                  icon={<RepeatIcon />}
                >
                  Regenerate PDF
                </MenuItem>

                <MenuItem
                  onClick={() => onSendReminder?.(invoice)}
                  icon={isSending ? <Spinner size="xs" /> : <RepeatIcon />}
                  isDisabled={isSending}
                >
                  {isSending ? "Sending Reminder..." : "Send Payment Reminder"}
                </MenuItem>

                <MenuItem
                  onClick={() => onEdit?.(invoice)}
                  icon={<EditIcon />}
                >
                  Edit Invoice
                </MenuItem>
              </MenuGroup>

              <MenuDivider />

              <MenuGroup title="Status">
                {invoice?.paid ? (
                  <MenuItem
                    onClick={() => onMarkUnpaid?.(invoice)}
                    icon={isUpdating ? <Spinner size="xs" /> : <CloseIcon />}
                    isDisabled={isUpdating}
                  >
                    Mark as Unpaid
                  </MenuItem>
                ) : (
                  <MenuItem
                    onClick={() => onMarkPaid?.(invoice)}
                    icon={isUpdating ? <Spinner size="xs" /> : <CheckCircleIcon />}
                    isDisabled={isUpdating}
                  >
                    Mark as Paid
                  </MenuItem>
                )}
              </MenuGroup>
            </MenuList>
    </Menu>
  );
};

export default InvoiceActionsMenu;
